






















import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-header-language-selector',
  components: {},
})
export default class HeaderLanguageSelector extends Vue {
  @Prop(Boolean) readonly right: boolean;
  @Prop(String) readonly variant: string;
  @Prop(String) readonly toggleClass: string;
  @Prop(Array) readonly languages: [];

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  get language(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get languageShortText(): string {
    return `global.short_lang.${this.language}`;
  }
  get availableLanguages() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].available_languages;
    }
    return [];
  }

  async changeLanguage(lang: string): Promise<void> {
    if (lang != this.language) {
      // If it is logged, update the profile before changing the language
      if (this.$store.getters['auth/isLoggedIn']) {
        const profile = this.$store.getters['auth/profile']({
          tenantId: this.$store.getters['tenant/selectedTenantId'],
        });
        await this.$store.dispatch('auth/updateProfileLanguage', {
          profileId: profile.id,
          language: lang,
        });
      }
      this.$store.commit('auth/setUserLang', lang);
      this.$router.go(0);
    }
  }
}
